import { Children, isValidElement, cloneElement } from 'react';

function hasChildren(element) {
  return /*#__PURE__*/isValidElement(element) && Boolean(element.props.children);
}
function hasComplexChildren(element) {
  return /*#__PURE__*/isValidElement(element) && hasChildren(element) && Children.toArray(element.props.children).reduce((response, child) => response || /*#__PURE__*/isValidElement(child), false);
}
function deepMap(children, deepMapFn) {
  return Children.toArray(children).map((child, index, mapChildren) => {
    if ( /*#__PURE__*/isValidElement(child) && hasComplexChildren(child)) {
      // Clone the child that has children and map them too
      return deepMapFn( /*#__PURE__*/cloneElement(child, {
        ...child.props,
        children: deepMap(child.props.children, deepMapFn)
      }));
    }
    return deepMapFn(child, index, mapChildren);
  });
}

export { deepMap as default };
